import { ObservableMap } from '@stencil/store';
import { State } from 'app/shared/store/models/state.model';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { changePlanService } from 'app/nbn/services/change-plan/change-plan.service';
import { removeHandler } from 'app/shared/store/handlers/types/remove-handler';

export const customerProfileHandler = (store: ObservableMap<State>): removeHandler => {
  return store.onChange(StoreKeys.customerProfile, async (data) => {
    if (data.existingNbnProductId && data.existingNbnProductId?.length > 0) {
      const currentPlan = await changePlanService.getCurrentPlan();
      store.set(StoreKeys.currentNbnPlan, currentPlan);
      sessionStorage.setItem('nbnExistingProductDetails', JSON.stringify(currentPlan));
    }
  });
};
